import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0646da6e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "break mx-[16px]" }, null, -1)
const _hoisted_2 = { class: "max-investment flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col flex-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-amount" }, "Totally you can invest"),
  /*#__PURE__*/_createElementVNode("div", null, "You can use all your tokens to maximize your investment")
], -1)
const _hoisted_4 = { class: "flex flex-col data-table-number-col  flex-1" }
const _hoisted_5 = { class: "max-amount" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = { class: "grid data-table" }
const _hoisted_9 = { class: "data-table-row total-row" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "data-table-number-col flex flex-col" }
const _hoisted_12 = { class: "total" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "data-table-number-col  flex flex-col" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = {
  key: 0,
  class: "text-sm font-semibold"
}
const _hoisted_17 = {
  key: 0,
  class: ""
}
const _hoisted_18 = {
  key: 1,
  class: "ml-[8px]"
}
_popScopeId()

import { computed, toRefs } from 'vue';

import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useWeb3 from '@/services/web3/useWeb3';

import { InvestMathResponse } from '../composables/useInvestMath';

/**
 * TYPES
 */
type Props = {
  math: InvestMathResponse;
  maxFiatValue: string;
};

/**
 * Props
 */

export default _defineComponent({
  props: {
    math: { type: null, required: true },
    maxFiatValue: { type: String, required: true }
  } as unknown as undefined,
  emits: ["maximize", "optimize"] as unknown as undefined,
  setup(__props: {
  math: InvestMathResponse;
  maxFiatValue: string;
}, { emit }: { emit: ({
  (e: 'maximize'): void;
  (e: 'optimize'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const { isWalletReady } = useWeb3();

const {
  fiatTotal,
  hasNoBalances,
  hasAllTokens,
  priceImpact,
  highPriceImpact,
  maximized,
  optimized,
  maximizeAmounts,
  batchSwapLoading,
  supportsPropotionalOptimization,
} = toRefs(props.math);


/**
 * COMPUTED
 */
const priceImpactClasses = computed(() => ({
  'small-btn': !highPriceImpact.value,
  'bg-red-500 dark:bg-red-500 text-white divide-red-400': highPriceImpact.value,
}));

const optimizeBtnClasses = computed(() => ({
  'text-gradient': !highPriceImpact.value,
  'text-red-500 px-2 py-1 bg-white rounded-lg': highPriceImpact.value,
}));

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(fNum2)(__props.maxFiatValue, _unref(FNumFormats).fiat)), 1),
        (_unref(isWalletReady) && !_unref(hasNoBalances))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(maximized))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('maxed')), 1))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "cursor-pointer small-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('maximize')))
                  }, _toDisplayString(_ctx.$t('maximize')), 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('total')), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(fNum2)(_unref(fiatTotal), _unref(FNumFormats).fiat)), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['data-table-row price-impact-row', _unref(priceImpactClasses)])
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.$t('priceImpact')) + " ", 1),
          _createVNode(_component_BalTooltip, {
            text: _ctx.$t('customAmountsTip')
          }, {
            activator: _withCtx(() => [
              (_unref(highPriceImpact))
                ? (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 0,
                    name: "alert-triangle",
                    size: "xs",
                    class: "-mb-px ml-1"
                  }))
                : (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 1,
                    name: "info",
                    size: "xs",
                    class: "-mb-px ml-1 text-gray-400"
                  }))
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              (
                _unref(isWalletReady) && _unref(hasAllTokens) && _unref(supportsPropotionalOptimization)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_unref(optimized))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('optimized')), 1))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "cursor-pointer small-btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('optimize')))
                        }, _toDisplayString(_ctx.$t('optimize')), 1))
                  ]))
                : _createCommentVNode("", true),
              (!_unref(batchSwapLoading))
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(fNum2)(_unref(priceImpact), _unref(FNumFormats).percent)), 1))
                : (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                    key: 2,
                    class: "w-10"
                  }))
            ])
          ])
        ])
      ], 2)
    ])
  ], 64))
}
}

})